import React, { useState, useEffect } from 'react'

import { gql } from '@apollo/client'
import { MenuItem, Select } from '@material-ui/core'
import { withTranslation } from 'react-i18next'
import { Loading } from '../Loading/Loading'

const query = gql`
    query {
        availableDomains {
            id
            name
        }
    }
`

export const DomainPicker = (props) => {
    const { selected, t } = props

    return (
        <Loading
            query={query}
            showLoading={false}
            showPreviousDataWhileLoading={true}
        >
            {(data) => {
                return (
                    <Domain
                        t={t}
                        domains={data.availableDomains || []}
                        style={props.style}
                        selected={selected}
                        onChangeDomain={props.onChangeDomain}
                    />
                )
            }}
        </Loading>
    )
}

export const Domain = (props) => {
    const { t, domains } = props

    const [selected, setSelected] = useState(props.selected || (domains[0]?.id ?? ''))

    useEffect(() => {
        if (props.onChangeDomain && selected) {
            props.onChangeDomain(selected)
        }
    }, []) // eslint-disable-line react-hooks/exhaustive-deps

    const handleChange = (event) => {
        setSelected(event.target.value)
        if (props.onChangeDomain) {
            props.onChangeDomain(event.target.value)
        }
    }

    return (
        <div>
            <span style={{ color: '#0000008a' }}>{t("Domain") + ": "}</span>
            <Select
                style={props.style}
                value={selected}
                onChange={handleChange}
            >
                {domains.map((domain) => (
                    <MenuItem
                        key={domain.id}
                        value={domain.id}>
                        {domain.name || null}
                    </MenuItem>
                ))}
            </Select>
        </div>
    )
}

export default withTranslation("DomainPicker")(DomainPicker)
